import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class ScrollSpeed extends BaseOption {
  static userInterfaceComponent = {
    label: "Scroll Speed",
    component: inspectorTools.SIMPLE_INPUT,
    props: {
      inputType: "number",
      min: 0,
      max: 100,
      append: "sec",
    },
  };

  static defaultValue = 12;
}
